"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _compositionsButtonWithIcon = _interopRequireDefault(require("@eig-builder/compositions-button-with-icon"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _imageProxyHelper = _interopRequireDefault(require("../helpers/image-proxy-helper"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _amcropper = _interopRequireDefault(require("../helpers/amcropper"));

var _amimageeffects = _interopRequireDefault(require("../helpers/amimageeffects"));

var _imageDetailsEffects = _interopRequireDefault(require("../controls/image-details-effects"));

var _imageZoomSlider = _interopRequireDefault(require("../controls/image-zoom-slider"));

var _imageAspectRatios = _interopRequireDefault(require("../controls/image-aspect-ratios"));

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _imageLibraryHelper = require("../helpers/image-library-helper");

var _hooks = require("../hooks");

var _classnames = _interopRequireDefault(require("classnames"));

require("./style/image-details.scss");

require("../lang");

var _templateObject, _templateObject2, _templateObject3;

var MainEditorBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background: #ccc;\n  height:100%;\n  position: relative;\n"])));

var StyledSaveButton = (0, _styledComponents["default"])(_compositionsButtonWithIcon["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 20px 10px !important;\n  position: absolute !important;\n  bottom: 0px;\n  width: 202px;\n\n  ", "\n"])), function (props) {
  return props.mobile && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    width: calc(100% - 20px) !important;\n    bottom: 10px !important;\n    margin: 10px !important;\n  "])));
});
var amcropper = null;
var amcropperLoaded = false;
var imageEffects = null;

var ImageDetails = function ImageDetails(_ref) {
  var _state$changedValues$, _state$changedValues, _state$changedValues$2;

  var selection = _ref.selection,
      uploadEdittedImage = _ref.uploadEdittedImage,
      dimensions = _ref.dimensions,
      loading = _ref.loading,
      setActionTop = _ref.setActionTop;

  var _useActiveView = (0, _hooks.useActiveView)('image-details'),
      active = _useActiveView.active;

  var mainCropperDiv = _react["default"].useRef(null);

  var _React$useState = _react["default"].useState({
    loading: false,
    cropAspect: null,
    hideAspectsSelector: dimensions.length === 2,
    changedValues: null,
    effectValues: {}
  }),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (active) {
      setActionTop([]);
    }
  }, [active]);

  _react["default"].useEffect(function () {
    (function () {
      if (amcropper && amcropperLoaded) {
        amcropper.destroy();
        amcropperLoaded = false;
      }
    });
  }, []);

  var reloadCropped = function reloadCropped() {
    var url = selection[0].original;
    var cdnUrl = new _imageProxyHelper["default"](url).result();
    var options = {
      cropAspect: state.cropAspect
    };

    if (dimensions.length === 2) {
      options.fixedAspect = dimensions[0] / dimensions[1];
      options.freeRotate = false;
    }

    amcropper.load(cdnUrl, options);
  };

  _react["default"].useEffect(function () {
    if (state.cropAspect) {
      reloadCropped();
    }
  }, [state.cropAspect]);

  var loadImageCropper = function loadImageCropper() {
    if (!amcropper || window.ie) {
      window.ie = imageEffects = new _amimageeffects["default"]();
      amcropper = new _amcropper["default"]();
      setState({
        effectValues: imageEffects.getAll()
      }); // only for debugging
      // window.amcropper = this.amcropper
      // window.ameffects = this.imageEffects
    }
  };

  var handleImageCropperLoad = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var initialImage, url, _selection$, originalHeight, originalWidth, originalRatio, options;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (amcropper) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              initialImage = ''; // are editting a free image? Then we have an original property.

              if (selection.length > 0 && 'original' in selection[0]) {
                url = selection[0].original;
                initialImage = new _imageProxyHelper["default"](url, 'cloudflare').result();
              } // for uploads, we have a base64 property


              if (selection.length > 0 && 'base64' in selection[0]) {
                initialImage = selection[0].base64;
              }

              _selection$ = selection[0], originalHeight = _selection$.originalHeight, originalWidth = _selection$.originalWidth;
              originalRatio = originalWidth / originalHeight;
              amcropper.initialize(mainCropperDiv.current, {
                convertSourceElement: function convertSourceElement(src) {
                  return imageEffects.setSource(src);
                }
              });
              options = {
                cropAspect: originalRatio,
                imageAspect: originalRatio
              };

              if (dimensions.length === 2) {
                options.fixedAspect = dimensions[0] / dimensions[1];
                options.freeRotate = false;
              }

              amcropper.load(initialImage, options);
              amcropperLoaded = true;

              amcropper.onChange = function (values) {
                return setState({
                  changedValues: values
                });
              };

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleImageCropperLoad() {
      return _ref2.apply(this, arguments);
    };
  }();

  _react["default"].useEffect(function () {
    if (mainCropperDiv === null || mainCropperDiv === void 0 ? void 0 : mainCropperDiv.current) {
      loadImageCropper();
      handleImageCropperLoad();
    }
  }, [mainCropperDiv.current]);

  var saveImage = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var downloadLocation, returnOptions, base64url;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              downloadLocation = selection[0].downloadLocation; // if the selection is unsplash, than we have a downloadLocation, else
              // its from my-images

              returnOptions = {};

              if (dimensions) {
                returnOptions.width = dimensions[0];
                returnOptions.height = dimensions[1];
              }

              if (!downloadLocation) {
                _context2.next = 6;
                break;
              }

              _context2.next = 6;
              return (0, _imageLibraryHelper.unsplashCallBack)({
                downloadLocation: downloadLocation
              });

            case 6:
              base64url = amcropper.getDataURL('image/jpeg', 70, returnOptions);
              _context2.next = 9;
              return uploadEdittedImage({
                base64: base64url,
                name: selection[0].description
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function saveImage() {
      return _ref3.apply(this, arguments);
    };
  }();

  var setRatio = function setRatio(ratio) {
    setState({
      cropAspect: ratio
    });
  };

  var setNewZoom = function setNewZoom(value) {
    amcropper.setZoom(-1, -1, value);
  };

  if (!active) {
    return null;
  }

  var _ref4 = selection && selection[0],
      originalHeight = _ref4.originalHeight,
      originalWidth = _ref4.originalWidth;

  var originalRatio = originalWidth / originalHeight;
  var effects = imageEffects && imageEffects.getEffectTemplates();
  var values = imageEffects && imageEffects.getAll();
  var isMD = (0, _mobileDetectionHelper["default"])();
  var mainClass = (0, _classnames["default"])('image-details--main', {
    mobile: isMD
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "image-picker--image-details"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: mainClass
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image-details--main--editor"
  }, /*#__PURE__*/_react["default"].createElement(_imageZoomSlider["default"], {
    setZoom: setNewZoom,
    value: (_state$changedValues$ = (_state$changedValues = state.changedValues) === null || _state$changedValues === void 0 ? void 0 : (_state$changedValues$2 = _state$changedValues.cropParams) === null || _state$changedValues$2 === void 0 ? void 0 : _state$changedValues$2.cropScale) !== null && _state$changedValues$ !== void 0 ? _state$changedValues$ : 0
  }), /*#__PURE__*/_react["default"].createElement(MainEditorBox, {
    ref: mainCropperDiv
  }), isMD && /*#__PURE__*/_react["default"].createElement(StyledSaveButton, {
    color: "primary",
    disabled: loading === true,
    onClick: saveImage,
    tag: "save-editted-image-from-library",
    dataElementLabel: "image-selector--details--save",
    dataElementLocation: _taggingHelper.DataElementLocations.FOOTER,
    dataElementId: "image-selector--details--save",
    size: "medium",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "image"
    }),
    fullWidth: true,
    mobile: true
  }, loading ? /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.savingImage"
  }) : /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.use"
  }))), !isMD && imageEffects && /*#__PURE__*/_react["default"].createElement("div", {
    className: "image-details--main--effects"
  }, /*#__PURE__*/_react["default"].createElement(_imageDetailsEffects["default"], {
    options: effects,
    values: values,
    getValue: imageEffects.get,
    set: function set() {
      var _imageEffects;

      (_imageEffects = imageEffects).set.apply(_imageEffects, arguments);

      var newValues = imageEffects.getAll();
      setState({
        effectValues: newValues
      });
    },
    reset: function reset() {
      imageEffects.setAll({}, true);
      var newValues = imageEffects.getAll();
      setState({
        effectValues: newValues
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_imageAspectRatios["default"], {
    setRatio: setRatio,
    originalRatio: originalRatio,
    cropAspect: state.cropAspect || originalRatio
  }), /*#__PURE__*/_react["default"].createElement(StyledSaveButton, {
    color: "primary",
    disabled: loading === true,
    onClick: saveImage,
    tag: "save-editted-image-from-library",
    dataElementLabel: "image-selector--details--save",
    dataElementLocation: _taggingHelper.DataElementLocations.FOOTER,
    dataElementId: "image-selector--details--save",
    size: "medium",
    labelPosition: "after",
    icon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "image"
    })
  }, loading ? /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.savingImage"
  }) : /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
    message: "imagepicker.use"
  })))));
};

ImageDetails.propTypes = {
  selection: _propTypes["default"].array.isRequired,
  uploadEdittedImage: _propTypes["default"].func.isRequired,
  dimensions: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  setActionTop: _propTypes["default"].func.isRequired
};

var _default = (0, _withContext["default"])(ImageDetails);

exports["default"] = _default;